/**
 * "Map colours only" mode for guests who join a shared world without a Minecraft jar at hand.
 *
 * Game textures are never shared (Mojang's assets may not be redistributed), so such a guest sees the
 * host's pre-baked region maps (one colour + height per block column) and can plan on them. There are no
 * 3D block meshes (detail chunks are switched off) and no block textures for materials.
 */
import type { AssetBundle } from "@mcp/assets";

export const MAP_COLOURS_LABEL = "Map colours only";

/** An asset bundle with no blocks: one neutral texture layer (layer 0 = "missing") and no models. */
export function mapColoursBundle(): AssetBundle {
  const size = 16;
  const pixels = new Uint8Array(size * size * 4);
  for (let i = 0; i < pixels.length; i += 4) { pixels[i] = 128; pixels[i + 1] = 128; pixels[i + 2] = 128; pixels[i + 3] = 255; }
  return {
    label: MAP_COLOURS_LABEL,
    blockstates: {},
    models: {},
    textures: { size, names: ["minecraft:missingno"], pixels, alpha: new Uint8Array([0]), avg: new Uint8Array([128, 128, 128]) },
    colormaps: { grass: null, foliage: null, dryFoliage: null },
  };
}
